export default {
  items: [],
  isLoading: false,
  isLoaded: false,
  error: null,
  processingIds: [],
};
